export function forgot({ payload }) {
  return {
    url: `/api/users/password/request_reset`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }
}

export function reset({ payload }) {
  return {
    url: `/api/users/password/reset`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }
}
